<template>
    <div class="spinner-container">
      <div class="spinner" />
    </div>
</template>
<style>
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    /* position: absolute; */
    /*
     * 확인을 기다리는 창보다 아래에 둔다 — 팝업(SweetAlert 1060)·2단계 인증 창(OtpVerifyModal 1100).
     *
     * 예전에는 9998 이라 로딩 중에 뜬 팝업을 덮었다. 팝업이 닫혀야 끝나는 작업을 스피너를 켠 채
     * 기다리면 「확인」을 누를 수 없어 화면이 멈췄다(앱 진입 「메뉴 로드 실패」·「토큰 만료」, 2026-10-28).
     * 일반 모달(1000)·셀렉트 드롭다운(1050)보다는 위라 저장 중에 모달을 다시 누르는 일은 그대로 막는다.
     */
    z-index: 1055;
  }
  .spinner {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 5px solid #e0e0e0;
    border-bottom: 5px solid #ffd814;
    animation: spin 1s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%, -50%);
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
  